import { CSSProperties, FC } from 'react'

import { AspectRatio, clsx } from '@mantine/core'

import { DataAttributeKey } from 'interfaces/types'

import {
  StyledHealthTool,
  StyledHealthToolIcon,
  StyledHealthToolTitle,
} from './CardHealthTool.styled'

export type CardHealthToolItem = {
  permalink: string
  title: string | JSX.Element
  icon: string | JSX.Element
}

export type CardHealthToolTrackingItem = {
  [DataAttributeKey: DataAttributeKey]: string | number
}

export type CardHealthToolTrackingProps = Partial<
  Record<'link', CardHealthToolTrackingItem>
>

export type CardHealthToolProps = {
  item: CardHealthToolItem
  itemTracking?: CardHealthToolTrackingProps
  className?: string
  style?: CSSProperties
}

export const CardHealthTool: FC<CardHealthToolProps> = (props) => {
  const { item, itemTracking, className, style } = props
  const { permalink, icon: iconProps, title } = item

  const icon =
    typeof iconProps === 'string' ? (
      <img loading="lazy" src={iconProps} alt="" />
    ) : (
      iconProps
    )

  return (
    <a
      href={permalink}
      {...itemTracking?.link}
      className={clsx(className, 'cardHealthTool')}
      {...itemTracking?.link}
    >
      <StyledHealthTool style={style}>
        <StyledHealthToolIcon className="cardHealthToolIcon">
          <AspectRatio ratio={1}>{icon}</AspectRatio>
        </StyledHealthToolIcon>
        <StyledHealthToolTitle className="cardHealthToolTitle">
          {title}
        </StyledHealthToolTitle>
      </StyledHealthTool>
    </a>
  )
}
